var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgImgx(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 474.16 474.16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#639540;stroke-width:20.62px;}.cls-2{fill:#639540;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Capa_1-2",
    "data-name": "Capa 1"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 237.08,
    cy: 237.08,
    r: 226.77
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_442",
    "data-name": "Trazado 442",
    className: "cls-1",
    d: "M355.49,127.53l-44.44,178.3-185.23,51.4L178.9,161.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M240.65,216.28a26.09,26.09,0,1,0,26.09,26.08,26.11,26.11,0,0,0-26.09-26.08m0-20.62a46.7,46.7,0,1,1-46.7,46.7A46.7,46.7,0,0,1,240.65,195.66Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgx);
export default __webpack_public_path__ + "static/media/imgx.a00db984ef78204cf3f0bc302c0a07ec.svg";
export { ForwardRef as ReactComponent };